import { ENGAGEMENT_FLOW_FINDING_KIND_URL_PARAM } from 'Core-utils/constants/constants';
import type { GridUrlState } from '../AgGridBase';

export const ENGAGEMENT_FLOW_FINDING_KINDS_COLUMN_ID = 'findingKinds';

export function mapEngagementFlowUrlToGridState(urlFilter: Record<string, unknown>): GridUrlState {
  const filterModel: Record<string, unknown> = {};
  const rawValue = urlFilter[ENGAGEMENT_FLOW_FINDING_KIND_URL_PARAM];

  if (rawValue !== undefined && rawValue !== null) {
    const values = (Array.isArray(rawValue) ? rawValue : [rawValue])
      .map((value) => String(value).trim())
      .filter(Boolean);

    if (values.length > 0) {
      filterModel[ENGAGEMENT_FLOW_FINDING_KINDS_COLUMN_ID] = {
        filterType: 'set',
        values,
      };
    }
  }

  return { filterModel, sortModel: [] };
}

export function mapEngagementFlowGridStateToUrl(gridState: GridUrlState): Record<string, string | string[]> {
  const params: Record<string, string | string[]> = {};
  const filterObj = gridState.filterModel[ENGAGEMENT_FLOW_FINDING_KINDS_COLUMN_ID] as
    | { values?: unknown[] }
    | undefined;

  if (filterObj && Array.isArray(filterObj.values) && filterObj.values.length > 0) {
    const values = filterObj.values.map((value) => String(value).trim()).filter(Boolean);
    if (values.length > 0) {
      params[ENGAGEMENT_FLOW_FINDING_KIND_URL_PARAM] = values;
    }
  }

  return params;
}
